import { main } from 'boot'
import reactive from './reactive'
import { TYPE }  from 'network/network_api';

import SETTINGS from 'settings'
SETTINGS.preserve_resource_format_for_all = true;

SETTINGS.bonusUserSelectionsPolicy = [
    {
        type : TYPE.BONUS_1,
        custom : true,
        plain_data : true,
    }
];

// hide ui panel
SETTINGS.ui_config = {};

// entry point
main({
    reactive,
});


// WEBPACK FOOTER //
// ./src/main.es6